<template>
	<div
		v-for="option in question.options"
		:key="option.uuid"
		class="mb-2"
	>
		<label class="has-cursor-pointer block">
			<input
				type="checkbox"
				:value="option.uuid"
				v-model="selectedAnswers"
				:disabled="isOptionsDisabled && !isSelectedOption(option)"
			/>
			{{ option.text }}
		</label>
		<div v-if="option.image">
			<dynamic-image :image="option.image"></dynamic-image>
		</div>
	</div>
</template>

<script lang="ts">
import DynamicImage from '@/components/ui/hoc/DynamicImage.vue'
import { QuestionItemMixin } from '@/utils/skill-assessment-mixins'
import { AnsweredQuestion, QuestionOption } from '@puls/puls-common-constants'
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [QuestionItemMixin],
	components: {
		DynamicImage
	},
	computed: {
		isOptionsDisabled () {
			const q = (this.question as AnsweredQuestion);
			if (!q.answers) {
				return false
			}
			return q.answers.length >= (q.max_correct || 1)
		}
	},
	methods: {
		isSelectedOption (option: QuestionOption): boolean {
			return this.selectedAnswers.includes(option.uuid);
		}
	}
})
</script>

<style scoped>

</style>
